// src/components/today/AllDayEventsSubHeader.tsx
import React from 'react';
import { Event } from '../../types/calendar-event';
import AllDayEventsBar from './AllDayEventsBar';

interface AllDayEventsSubHeaderProps {
  allDayEvents: Event[];
}

const AllDayEventsSubHeader: React.FC<AllDayEventsSubHeaderProps> = ({ 
  allDayEvents 
}) => {
  if (!allDayEvents || allDayEvents.length === 0) {
    return null;
  }

  return (
    <div className="bg-white">
      <AllDayEventsBar allDayEvents={allDayEvents} />
    </div>
  );
};

export default AllDayEventsSubHeader;